import axios from 'axios'

var qs = require('qs');
var root = window.API_ROOT


//获取列表数据
export const getListData = (params) => {
  return axios.post(root + '/set/machinecoupon/datalist', qs.stringify(params))
}


//获取列表数据
export const saveData = (params) => {
  return axios.post(root + '/set/machinecoupon/save_from_web', qs.stringify(params))
}
//新增行
export const machImport = (params) => {
  return axios.post(root + '/set/machinecoupon/save_import_web', qs.stringify(params))
}
//修改
export const update = (params) => {
  return axios.post(root + '/set/machinecoupon/update', qs.stringify(params))
}

export const listCash=(params) => {
  return axios.post(root+'/set/machinecoupon/listCash',qs.stringify(params),{noloading:true})
}







// WEBPACK FOOTER //
// ./src/api/set/machinecoupon.js